<template>
  <GoogleLogin :params="params" :onSuccess="onSuccess" :onFailure="onFailure" class="google-button" :disable="loading">
    <Loader v-if="loading" color="white" size="2.5rem" />
    <fragment v-else>Signed in with Google</fragment>
  </GoogleLogin>
</template>

<script>
import GoogleLogin from 'vue-google-login';
import { mapActions } from 'vuex';

import Loader from '@/components/Loader';

export default {
  name: 'GGLoginButton',
  components: {
    GoogleLogin,
    Loader,
  },
  data() {
    return {
      params: {
        client_id: '1061736728502-d0s6mub9tj37gtmr3fpmijaj6h04mo68.apps.googleusercontent.com',
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions('app', ['login']),
    onSuccess(googleUser) {
      const { id_token } = googleUser.getAuthResponse();
      const profile = googleUser.getBasicProfile();

      const user = {
        id: profile.getId(),
        name: profile.getName(),
        img: profile.getImageUrl(),
        email: profile.getEmail(),
        idToken: id_token,
      };

      this.$store.commit('app/user', user);

      this.loading = true;
      this.login().then(() => {
        this.$router.push('/rw-form');
      });
    },
    onFailure(err) {
      console.error('---- GoogleLogin onFailure,', err);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors';

.google-button {
  min-width: 20rem;
  height: 5rem;

  display: flex;
  justify-content: center;
  align-items: center;

  outline: none;
  border-radius: 1rem;
  background: $darkBlue;
  color: white;
}
</style>
